export default __webpack_public_path__ + "static/media/Top_Product_Mobile.79ada8d6.jpg";